import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderStudentComponent } from '../components/header-student/header-student.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderInstructorComponent } from '../components/header-instructor/header-instructor.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker';
import { TranslateModule } from '@ngx-translate/core';
import { ClaAlertComponent } from '../components/cla-alert/cla-alert.component';
import { AlertModule as MkAlertModule, BoxModule } from 'angular-admin-lte';
import { BoxInfoModule as MkBoxInfoModule } from 'angular-admin-lte';
import { MieiGruppiStudioAccordionComponent } from '../components/accordion-miei-gruppi-studio/accordion-miei-gruppi-studio.component';
import { AccordionModule as MkAccordionModule } from 'angular-admin-lte';
import { PaginatoreModule } from '../components/paginatore/paginatore.module';
import { TabellaComponent } from '../components/tabella/tabella.component';
import { BarChartComponent } from '../components/bar-chart/bar-chart.component';
import { ChartsModule } from 'ng2-charts';
import { PieChartComponent } from '../components/pie-chart/pie-chart.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MkAccordionModule,
    ReactiveFormsModule,
    MatFileUploadModule,
    A2Edatetimepicker,
    MkAlertModule,
    BoxModule,
    PaginatoreModule,
    MkBoxInfoModule,
    ChartsModule,
  ],
  declarations: [
    HeaderStudentComponent,
    TabellaComponent,
    HeaderInstructorComponent,
    ClaAlertComponent,
    PieChartComponent,
    BarChartComponent,
    MieiGruppiStudioAccordionComponent,
  ],
  exports: [
    HeaderStudentComponent,
    HeaderInstructorComponent,
    PaginatoreModule,
    FormsModule,
    ReactiveFormsModule,
    MatFileUploadModule,
    MkAlertModule,
    BoxModule,
    TabellaComponent,
    MkBoxInfoModule,
    A2Edatetimepicker,
    TranslateModule,
    MkAccordionModule,
    ClaAlertComponent,
    BarChartComponent,
    PieChartComponent,
    MieiGruppiStudioAccordionComponent,
    ChartsModule,
  ],
})
export class SharedComponentsModule {}
